module.exports = __webpack_public_path__ + "img/icon_office_white.bfa5f169.svg";